<template>
  <div class="carousel_items  wow fadeInUp catalog_page__filter" data-wow-delay="0.7s">
    <agile :initial-slide="0" :options="options_main_slider" class="catalog_page__filter_contents">

      <div
          class="slide filter_contents__item mb-0 market  position-relative"
          v-for="(item, index) of items">
        <div class="bar_item__content h-100">
          <div class="item_plain h-100">
            <div class="d-flex h-100 item_plain__content item_polls flex-column">
              <div class="market__img d-flex justify-content-center">
                <img :src="item.img">
              </div>
              <div class="w-100 h-100 justify-content-between flex-column d-flex item_plain__descr">

                <div class="item_plain__title flex-grow-1">
                  {{ item.name }}
                </div>

<!--                <div class="d-flex align-items-center market__btn my-0">-->
<!--                  <a :href="item.url" class="btn btn_red market_redeem ">Подробнее</a>-->
<!--                </div>-->

              </div>

            </div>
          </div>
        </div>
        <a :href="item.url" class="w-100 position-absolute h-100 l-0 t-0 zi-1"></a>
      </div>

      <template slot="prevButton">
        <svg
            width="19"
            height="18"
            viewBox="0 0 19 18"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
          <path
              d="M11.5 4.5L7 9L11.5 13.5"
              stroke="white"
              stroke-width="2.4"
              stroke-linecap="round"
              stroke-linejoin="round"
          />
        </svg>
      </template>
      <template slot="nextButton">
        <svg
            width="19"
            height="18"
            viewBox="0 0 19 18"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
          <path
              d="M7.5 13.5L12 9L7.5 4.5"
              stroke="white"
              stroke-width="2.4"
              stroke-linecap="round"
              stroke-linejoin="round"
          />
        </svg>
      </template>
    </agile>
  </div>
</template>

<script>
export default {
  props: {
    items: Array | String | Number | Boolean | Object,
  },
  name: "carouselItems",
  data() {
    return {
      options_main_slider: {
        navButtons: false,
        dots: true,
        infinite: this.items.length > 1 ? true:false,
        autoplay: true,
        slidesToShow: 1,
        // pauseOnDotsHover: true,
        pauseOnHover: false,
        // navButtons: true,
        autoplaySpeed: "5000",
        speed: "1000",
        responsive: [
          {
            breakpoint: 1200,
            settings: {
              slidesToShow: 4,
              dots: false,
              navButtons: true,
            },
          },
          {
            breakpoint: 600,
            settings: {
              slidesToShow: 2,
              dots: false,
              navButtons: true,
            },
          },

        ],
      },

      // items: [
      //   {
      //     name: "Пленки для упаковки свежих овощей и салатов",
      //     img: "/upload/filter_img/Пленки-для-флоу-пак-упаковки 9.png",
      //     url: "#",
      //     id: "",
      //   },
      //   {
      //     name: "Пленки для запайки лотков и стаканов",
      //     img: "/upload/filter_img/Пленки-для-флоу-пак-упаковки 8.png",
      //     url: "#",
      //     id: "",
      //   },
      //   {
      //     name: "Пленки для барьерной упаковки",
      //     img: "/upload/filter_img/Пленки-для-флоу-пак-упаковки 7.png",
      //     url: "#",
      //     id: "",
      //   },
      //   {
      //     name: "Пленка для упаковки лекарств и медицинских изделий",
      //     img: "/upload/filter_img/Пленки-для-флоу-пак-упаковки 6.png",
      //     url: "#",
      //     id: "",
      //   },
      //   {
      //     name: "Круговая БОПП этикетка",
      //     img: "/upload/filter_img/Пленки-для-флоу-пак-упаковки 5.png",
      //     url: "#",
      //     id: "",
      //   },
      //   {
      //     name: "Пленки для ламинации",
      //     img: "/upload/filter_img/Пленки-для-флоу-пак-упаковки 4.png",
      //     url: "#",
      //     id: "",
      //   },
      //   {
      //     name: "Покрывные пленки для вакуумной упаковки",
      //     img: "/upload/filter_img/Пленки-для-флоу-пак-упаковки 3.png",
      //     url: "#",
      //     id: "",
      //   },
      //   {
      //     name: "БОПП пленки различного назначения",
      //     img: "/upload/filter_img/Пленки-для-флоу-пак-упаковки 2.png",
      //     url: "#",
      //     id: "",
      //   },
      //   {
      //     name: "Пленки для замороженной продукции",
      //     img: "/upload/filter_img/Пленки-для-флоу-пак-упаковки 1.png",
      //     url: "#",
      //     id: "",
      //   },
      //
      // ],

    };
  },
  methods: {},
};
</script>
<style lang="scss" scoped>
@import "../../theme/_variable.scss";
</style>

<style lang="scss">
.catalog_page__detail {
  & a.btn_red:active {
    transition: none;
  }

  & .mayBeOfInterest {
    margin-top: 110px;
  }

  & .catalog_page__detail_item {
    margin-bottom: 60px;


    & .h3 {
      font-style: normal;
      font-weight: 600;
      font-size: 20px;
      line-height: 100%;
      color: #282828;
      font-family: "MuseoSansCyrl-700";
      margin-bottom: 24px;
    }

    & p,
    & div {
      font-style: normal;
      font-weight: 400;
      font-size: 16px;
      line-height: 150%;
      color: #282828;
      font-family: "MuseoSansCyrl-500";
    }
  }

  & .h2_title {
    border-bottom: none;
    font-style: normal;
    font-weight: 600;
    font-size: 40px;
    line-height: 100%;
    font-family: "MuseoSansCyrl-700";
    color: #282828;
    padding-bottom: 0;
  }

  & .title_block {
    margin-bottom: 50px;
  }
}

.carousel_items {
  margin-top: 0px;

  & .filter_contents__item {
    height: 100%;
  }

  & .agile__actions {
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    position: absolute;
    margin-right: 0;
    -webkit-box-pack: normal;
    -ms-flex-pack: normal;
    justify-content: normal;
    right: 0;
    top: -85px;
  }

  & .agile__nav-button {
    border: none;
    color: #fff;
    font-size: 24px;
    position: relative;
    -webkit-transition-duration: 0.3s;
    -o-transition-duration: 0.3s;
    transition-duration: 0.3s;
    width: 30px;
    height: 30px;
    background: #282828;
    border-radius: 50%;
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-align: center;
    -ms-flex-align: center;
    align-items: center;
    -webkit-box-pack: center;
    -ms-flex-pack: center;
    justify-content: center;
  }

  & .agile__slides {
    -webkit-touch-callout: none;
    -webkit-user-select: none;
    -moz-user-select: none;
    -ms-user-select: none;
    user-select: none;

  }


  & .agile__list {
    background: #ffffff;
    -webkit-box-shadow: none;
    box-shadow: none;
    border-radius: 0;
  }

  .agile__nav-button:hover {
    background-color: rgba(0, 0, 0, 0.5);
    opacity: 1;
  }

  .agile__nav-button--prev {
    left: -10px;
  }

  .agile__nav-button--next {
    right: 0;
  }

}
</style>
